import { Link, FieldProps, useRecordContext } from 'react-admin';
import { Ecom_Categories } from '../../custom';

const ProductTemplatesLinkField = (props: FieldProps<Ecom_Categories>) => {
    const record = useRecordContext<Ecom_Categories>();
    if (!record) {
        return null;
    }
    return (
        <Link to={`/ecom_categories/${record.id}/ecom_product_templates`}>Product Templates</Link>
    );
};

ProductTemplatesLinkField.defaultProps = {
    label: 'Product Templates',
};

export default ProductTemplatesLinkField;
